export default __webpack_public_path__ + "static/liner6-a9bc3651247da063e3c0ea7fb1c0c607.jpeg";